import { useTranslation } from "react-i18next";
import { Lock } from "lucide-react";

import RequirementBadge from "@/features/certifications/module/components/RequirementBadge";
import { LockedRequirementCardProps } from "@/features/certifications/module/components/types";

import "./styles.css";

const ICON_SIZE = 18;

const LockedRequirementCard = ({
  title,
  body,
  switchLabel,
  onSwitch,
}: LockedRequirementCardProps) => {
  const { t } = useTranslation();

  return (
    <section className="certification-card module-card module-card-body flex flex-col gap-400">
      <div className="flex items-center justify-between gap-300">
        <h2 className="module-locked-title header-s-medium">{title}</h2>

        <RequirementBadge isRequired={false} />
      </div>

      <div className="module-locked-body flex flex-col items-center gap-300">
        <span className="module-disc module-disc-muted flex items-center justify-center">
          <Lock size={ICON_SIZE} aria-hidden />
        </span>

        <h3 className="module-locked-heading header-s-medium">
          {t("certification.module.notRequired")}
        </h3>

        <p className="certification-muted body-s-regular">{body}</p>

        {switchLabel && (
          <button
            type="button"
            className="certification-link-button body-s-medium"
            onClick={onSwitch}
          >
            {switchLabel}
          </button>
        )}
      </div>
    </section>
  );
};

export default LockedRequirementCard;
